import React from "react";
import {
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface BarChartProps {
  data: any[];
  dataKey: string;
  xKey: string;
  barColor?: string;
  height?: string;
}

const CustomBarChart: React.FC<BarChartProps> = ({
  data,
  dataKey,
  xKey,
  barColor = "#3B82F6",
  height = "h-[28rem]",
}) => (
  <div className={`w-full flex items-center justify-center relative ${height}`}>
    <ResponsiveContainer width="100%" height="100%">
      <ReBarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
        <XAxis dataKey={xKey} stroke="#6B7280" fontSize={12} />
        <YAxis stroke="#6B7280" fontSize={12} />
        <Tooltip />
        <Bar dataKey={dataKey} fill={barColor} radius={[6, 6, 0, 0]} />
      </ReBarChart>
    </ResponsiveContainer>
  </div>
);

export default CustomBarChart;
